const OG_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/can-into-space.appspot.com/o/homesite%2Ffutureishere_max.jpg?alt=media&token=0a509598-13bc-4002-9136-c5db09e034bd";
const BASE_URL = "https://caninto.space";
const TWITTER_HANDLE = "@CanIntoSpace83";

const PageMeta = ({ title, description, path = "", image = OG_IMAGE }) => {
  const fullTitle = title
    ? `${title} | Michał Nierebiński`
    : "Michał Nierebiński | Can into Space";
  const url = `${BASE_URL}${path}`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content={TWITTER_HANDLE} />
      <meta name="twitter:site" content={TWITTER_HANDLE} />
    </>
  );
};

export default PageMeta;
